{
  "authors": {
    "from": "av {{author}}",
    "byline": "Byline {{author}}",
    "lastDoneMarked": "Sist klarmarkert {{created}} av {{author}}",
    "doneBy": "Klarmarkert av {{author}}",
    "createdBy": "Opprettet av {{author}}",
    "approvedBy": "Godkjent av {{author}}",
    "statusTimeBy": "{{status}} {{created}} av {{author}}"
  },
  "assignmentTypes": {
    "text": "Artikkel",
    "flash": "HAST",
    "editorial-info": "PRIV",
    "graphic": "Grafikk",
    "picture": "Foto",
    "video": "Video",
    "picture/video": "Foto/Video",
    "live-streaming": "Live",
    "timeless": "Tidløs"
  },
  "toolbar": {
    "clearFilters": "Tøm",
    "savePersonalFilter": "Lagre personlig filter",
    "personalFilter": "Personlig filter",
    "toggleUserFilter": "Vexle brukerfilter",
    "toggleLabel": "Vexle {{label}}",
    "navigateToday": "Gå til idag",
    "freeText": "Fritekst",
    "freeTextSearch": "Fritekstsøkning",
    "altSearch": "Søkealternativer"
  },
  "status_menu": {
    "cause": "Grunn",
    "pickCause": "Velg en grunn...",
    "planningDate": "Dato",
    "setTime": "Skriv inn tid",
    "asSavePlaceholder": "Publiser ny informasjon",
    "embargoMinTime": "Embargo: kan ikke planlegges før {{time}}",
    "timeInPast": "Valgt tid har passert",
    "planningDateInPast": "Planens dato har passert. Flytt oppdraget til en plan for dagen du vil publisere.",
    "beforeEmbargo": "Tiden er før embargo",
    "timezoneMismatch": "Enheten din er stilt inn på en annen tidssone enn den som brukes i systemet. Angi tid for publisering i systemets tidssone (forskjell {{offset}}).",
    "publishesInDefaultTz": "Publiseres {{time}} (systemets tidssone)",
    "publishesInUserTz": "= {{time}} i din tidssone ({{tz}})",
    "schedulingRequiresPlanning": "Planen er ikke tilgjengelig fordi dokumentet mangler en tilknyttet plan.",
    "titleFallback": "Tittel mangler i artikkelen! Oppgavens tittel \"{{title}}\" brukes.",
    "titleMissingBoth": "Tittel mangler i både artikkelen og oppgaven.",
    "causes": {
      "development_short": "UV",
      "development_long": "Utvikling",
      "fix_short": "KORR",
      "fix_long": "Korreksjon",
      "correction_short": "RET",
      "correction_long": "Rettelse",
      "retransmission_short": "OMS",
      "retransmission_long": "Gjenutgivelse"
    }
  },
  "copy": {
    "copiedTo": "Kopiert til",
    "copiedFrom": "Kopiert fra",
    "copyType": "Kopiere {{type}}",
    "copyPrompt": "Vil du kopiere \"{{title}}\" til {{start}}?",
    "copySuccess": "\"{{title}}\" har blitt kopiert til {{start}}",
    "copyEventPrompt": "Vil du kopiere hendelsen til {{datesFormatted}}?",
    "copyEventSuccess": "Hendelsen \"{{title}}\" har blitt kopiert til {{datesFormatted}}"
  },
  "operations": {
    "authorCreateSuccess": "Forfatterdokument er opprettet",
    "authorUpdateSuccess": "Forfatterdokumentet er oppdatert",
    "authorSaveSuccess": "Forfatterdokumentet er lagret",
    "savedFilter": "Filteret ditt er lagret",
    "documentSaveSuccess": "Dokument lagret"
  },
  "prompts": {
    "publishBeforeClose": "Vil du publisere endringer før du lukker?",
    "savedButNotPublished": "Endringene er lagret, men ikke publisert."
  },
  "editorialInfo": {
    "noteText": "OBS! Denne meldingen er ikke ment for publisering."
  },
  "init": {
    "failedTitle": "Kunne ikke initialisere",
    "retryButton": "Prøv igjen"
  }
}
